<template>
    <http-delete-button
        v-bind="$props"
        v-on="$listeners"
        :href="apiKeyId ? `/api/apikeys/${apiKeyId}` : null"
        version="v2"
        @http4xx="onError"
    />
</template>

<i18n>
{
    "en": {
        "deleteApiKeyButton.errorMessage": "There was an issue deleting the api key."
    }
}
</i18n>

<script>
import { toastError } from '@/components/Common/Toast.vue';
import HttpDeleteButton from '@/components/Common/HttpDeleteButton.vue';

export default {
    components: { HttpDeleteButton },
    props: {
        ...HttpDeleteButton.props,
        apiKeyId: [String, Number]
    },
    methods: {
        onError() {
            toastError(this.$t('deleteApiKeyButton.errorMessage'));
        }
    }
};
</script>
